import React, { useEffect, useState } from "react";
import { Box, IconButton } from "@mui/material";
import styled from "styled-components";
import { Turn as Hamburger } from "hamburger-react";

const SidebarContainer = styled(Box)`
  position: fixed;
  top: 5%;
  left: 10px;
  background-color: #eeedeb;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: width 0.5s ease-in-out;
  width: ${({ open }) => (open ? "48px" : "48px")};
  height: ${({ open }) => (open ? "auto" : "48px")};
  gap: 10px;
  padding-bottom: ${({ open }) => (open ? "10px" : "0px")};
`;

const IconButtonStyled = styled(IconButton)`
  transition: transform 0.3s, opacity 0.3s;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transform: ${({ visible }) => (visible ? "scale(1)" : "scale(0.8)")};
`;

const HamburgerContainer = styled(Box)`
  z-index: 1100;
`;

const AnimatedMenu = ({ sessionId, sendRotateCall, controlData }) => {
  const [open, setOpen] = useState(false);
  const [controlStates, setControlStates] = useState({});

  useEffect(() => {
    if (controlData?.length) {
      const initialStates = {};
      controlData.forEach((control) => {
        if (control.control_data_type === "boolean") {
          initialStates[control.control_id] = Boolean(control.default_value);
        }
      });
      setControlStates(initialStates);
    }
  }, [controlData]);

  const handleToggle = (control) => {
    const isBoolean = control.control_data_type === "boolean";
    const currentValue = controlStates?.[control.control_id] ?? false;
    const newValue = isBoolean ? !currentValue : true;

    const payload = {
      session_id: sessionId,
      message: {
        type: "control",
        message: {
          control_id: control.control_id,
          value: newValue.toString(),
        },
      },
    };

    sendRotateCall(payload);

    if (isBoolean) {
      setControlStates((prev) => ({
        ...prev,
        [control.control_id]: newValue,
      }));
    }
  };

  return (
    <SidebarContainer open={open}>
      <HamburgerContainer>
        <Hamburger
          toggled={open}
          toggle={setOpen}
          size={20}
          direction="right"
        />
      </HamburgerContainer>

      {open &&
        controlData?.map((control) => {
          const icon = control?.control_icons?.find(
            (icon) => icon.file_type === "L"
          );

          const isBoolean = control.control_data_type === "boolean";
          const isSelected =
            isBoolean && controlStates?.[control.control_id] === true;

          return (
            <Box
              key={control.control_id}
              sx={{
                backgroundColor: isSelected ? "white" : "transparent",
                borderRadius: "10px",
              }}
            >
              <IconButtonStyled
                visible={open}
                onClick={() => handleToggle(control)}
              >
                <img
                  src={icon?.path}
                  alt={control?.control_name}
                  style={{ width: 18, height: 18 }}
                />
              </IconButtonStyled>
            </Box>
          );
        })}
    </SidebarContainer>
  );
};

export default AnimatedMenu;
